module.exports = __webpack_public_path__ + "static/media/8.abd38e41.png";